import Lazy from './Lazy';

class LazyImgSlow extends Lazy{

    constructor(selector='.lazy-img-slow') {
        super({
            targets: selector,
            loadFn: imgEl => {
                const imgSrc = imgEl.getAttribute('data-lazy');
                if(imgSrc) {
                    const img = document.createElement('img');
                    img.onload = () => {
                        imgEl.src = imgSrc;
                    }
                    img.src = imgSrc;
                }
            },
            threshold: 0.01,
            rootMargin: {top: 0, right: 0, left: 0, bottom: 0},
            persist: false,
            simLoadLimit: 1,
            simLoadDelay: 200,
        })
    }
}

export default LazyImgSlow;
